import script from "./AgendaConsultorioView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaConsultorioView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__